const Benefit = {
  AddBenefit: "Benefit.AddBenefit",
  UpdateBenefit: "Benefit.UpdateBenefit",
  BenefitTypeLabel: "Benefit.BenefitTypeLabel",
  NameLabel: "Benefit.NameLabel",
  DeductionNameLabel: "Benefit.DeductionNameLabel",
  FrequencyLabel: "Benefit.FrequencyLabel",
  Frequency_0: "Benefit.Frequency_0",
  Frequency_1: "Benefit.Frequency_1",
  OneTimeDeduction: "Benefit.OneTimeDeduction",
  BenefitValueLabel: "Benefit.BenefitValueLabel",
  DeductionAmountLabel: "Benefit.DeductionAmountLabel",
  BenefitValueDescriptionPart1: "Benefit.BenefitValueDescriptionPart1",
  BenefitValueDescriptionLink: "Benefit.BenefitValueDescriptionLink",
  BenefitValueDescriptionPart2: "Benefit.BenefitValueDescriptionPart2",
  BenefitCreatedSuccess: "Benefit.BenefitCreatedSuccess",
  MonthSelectorDescription: "Benefit.MonthSelectorDescription",
  Type_0: "Benefit.Type_0",
  Type_1: "Benefit.Type_1",
  Type_2: "Benefit.Type_2",
  Type_3: "Benefit.Type_3",
  Type_4: "Benefit.Type_4",
  Type_5: "Benefit.Type_5",
  Type_6: "Benefit.Type_6",
  Type_7: "Benefit.Type_7",
  Type_8: "Benefit.Type_8",
  Type_9: "Benefit.Type_9",
  Type_10: "Benefit.Type_10",
  Type_11: "Benefit.Type_11",
  Type_12: "Benefit.Type_12",
  TypeDescription_0: "Benefit.TypeDescription_0",
  TypeDescription_1: "Benefit.TypeDescription_1",
  TypeDescription_2: "Benefit.TypeDescription_2",
  TypeDescription_3: "Benefit.TypeDescription_3",
  TypeDescription_4: "Benefit.TypeDescription_4",
  TypeDescription_5: "Benefit.TypeDescription_5",
  TypeDescription_6: "Benefit.TypeDescription_6",
  TypeDescription_7: "Benefit.TypeDescription_7",
  TypeDescription_8: "Benefit.TypeDescription_8",
  TypeDescription_9: "Benefit.TypeDescription_9",
  TypeDescription_10: "Benefit.TypeDescription_10",
  TypeDescription_11: "Benefit.TypeDescription_11",
  TypeDescription_12: "Benefit.TypeDescription_12",
  BenefitsTitle: "Benefit.BenefitsTitle",
  NameColumn: "Benefit.NameColumn",
  BenefitTypeColumn: "Benefit.BenefitTypeColumn",
  BenefitValueColumn: "Benefit.BenefitValueColumn",
  PeriodColumn: "Benefit.PeriodColumn",
  AllEmployeeGroupTitle: "Benefit.AllEmployeeGroupTitle",
  SpecificEmployeeGroupTitle: "Benefit.SpecificEmployeeGroupTitle",
  AllEmployeeItemLabel: "Benefit.AllEmployeeItemLabel",
  GroupSelectionLabel: "Benefit.GroupSelectionLabel",
  GroupSelection_0: "Benefit.GroupSelection_0",
  GroupSelection_1: "Benefit.GroupSelection_1",
  RetroactiveBenefitWarning: "Benefit.RetroactiveBenefitWarning",
  BenefitUpdatedSuccess: "Benefit.BenefitUpdatedSuccess",
  BenefitAmountEffectFromLabel: "Benefit.BenefitAmountEffectFromLabel",
  BenefitAmountEffectFromDescription: "Benefit.BenefitAmountEffectFromDescription",
  EmployeesExpansionListTitle: "Benefit.EmployeesExpansionListTitle",
  CarBenefitSearchMethod_0: "Benefit.CarBenefitSearchMethod_0",
  CarBenefitSearchMethod_1: "Benefit.CarBenefitSearchMethod_1",
  CarBenefitSearchMethod_2: "Benefit.CarBenefitSearchMethod_2",
  CarBenefitSearchMethodLabel: "Benefit.CarBenefitSearchMethodLabel",
  CarBenefitModelNumberLabel: "Benefit.CarBenefitModelNumberLabel",
  CarBenefitCostOfExtraEquipmentLabel: "Benefit.CarBenefitCostOfExtraEquipmentLabel",
  CarBenefitAnnualTaxLabel: "Benefit.CarBenefitAnnualTaxLabel",
  CarBenefitNo10KmDrivenInServiceLabel: "Benefit.CarBenefitNo10KmDrivenInServiceLabel",
  CarBenefitNo10KmDrivenInServiceDescription: "Benefit.CarBenefitNo10KmDrivenInServiceDescription",
  CarBenefitDateOfRegistrationLabel: "Benefit.CarBenefitDateOfRegistrationLabel",
  CarBenefitDateOfRegistrationDescription: "Benefit.CarBenefitDateOfRegistrationDescription",
  CarBenefitYearLabel: "Benefit.CarBenefitYearLabel",
  CarBenefitBrandLabel: "Benefit.CarBenefitBrandLabel",
  CarBenefitVehicleLabel: "Benefit.CarBenefitVehicleLabel",
  CarBenefitVehicleDescription: "Benefit.CarBenefitVehicleDescription",
  }
export default Benefit;